/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { Component, OnChanges, OnDestroy, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { BaseResponse } from '../../../core/model/base-response.model';
import { LocoDetail } from '../../../core/model/loco-detail.model';
import { MessageDetails } from '../../../core/model/message-details.model';
import { Tab } from '../../../core/model/tab.model';
import { TerminalCommonInfo } from '../../../core/model/terminal-common-info.model';
import { TerminalHandlingLocoInfo } from '../../../core/model/terminal-handling-loco-info.model';
import { TerminalHandlingUpdateRequest } from '../../../core/model/terminal-handling-update-request-model';
import { LmsLoaderService } from '../../../core/services/lms-loader.service';
import { MessageHandlerService } from '../../../core/services/message-handler.service';
import { PopupService } from '../../../core/services/popup.service';
import { StaticDataStoreService } from '../../../core/services/static-datastore.service';
import { TrainDataService } from '../../../train/services/train-data.service';
import { AllocDeallocData } from '../../../yard-local/shared/model/alloc-dealloc-data.model';
import { AllocationStation } from '../../model/allocation-station.model';
import { Header } from '../../model/header.model';
import { TrainData } from '../../model/train-data.model';
import { AppUtilityService } from '../../services/app-utility.service';
import { ConfigService } from '../../services/config.service';
import { ContextMenuOperationsService } from '../../services/context-menu-operations.service';
import { LmsModuleService } from '../../services/lms-module.service';
import { UserService } from '../../services/user.service';



/**
 * @export
 * @class DialogOperationComponent
 * @implements {OnInit}
 * @implements {OnChanges}
 * @implements {OnDestroy}
 */
@Component({
  selector: 'lms-dialog-operation',
  templateUrl: './dialog-operation.component.html',
  styleUrls: ['./dialog-operation.component.scss']
})
export class DialogOperationComponent implements OnInit, OnChanges, OnDestroy {

  popupOpr: any;

  locomotive: LocoDetail;
  trainData: TrainData;
  locomotives: LocoDetail[];
  selectedTab: Tab;
  responseHeader: BaseResponse;
  configData: any;
  popUpServiceSubscription: any;
  terminalCommonInfoArr: Array<TerminalCommonInfo>; // This is terminal info array which we are using for getting City and state

  popupErrorMessage: string;
  searchTerminalMenmonic: string;
  searchTerminalCityState: string;
  thpPlan: string;
  confirmAction: string;
  confirmMessage: string;
  windowCode: string;
  initWindowCount: number;
  locomotiveIdentifier: string;

  errorDialog: boolean;
  isShowTerminalPlan: boolean;
  confirmPop: boolean;
  terminalScreen: boolean;
  isShowUserProfile: boolean;
  searchTerminalMenmonicError = false;
  mnemonics: Array<string>;
  mileposts: Array<string>;
  filteredResults: Array<string>;
  yardAndLocal = false;
  tabLevel: number;
  commonopsPicklist: any;
  allocateLocomotive: boolean;
  searchAllocationStationError: boolean;
  allocationStationArr: Array<AllocationStation> = [];

  /* for allocate and de-allocate popup */
  allocationType = 'YL';
  searchTextAllocationStation: string;
  permanentAllocation: boolean;
  allocateRole: string;
  allocateDeallocateResponse: Header;
  permannentAllocMsg: string;
  permannentAllocDialog: boolean;
  permannentAllocForDeallocDialog: boolean;
  deAllocateLocomotive: boolean;

  /**
   * Creates an instance of DialogOperationComponent.
   * @param {StaticDataStoreService} staticDataStoreService
   * @param {PopupService} popUpSerives
   * @param {MessageHandlerService} messageHandlerService
   * @param {LmsLoaderService} lmsLoaderService
   * @param {TrainDataService} trainDataServie
   * @param {ConfigService} configService
   * @param {AppUtilityService} appUtilityService
   * @memberOf DialogOperationComponent
   */
  constructor(private staticDataStoreService: StaticDataStoreService,
    private popUpSerives: PopupService,
    private messageHandlerService: MessageHandlerService,
    private lmsLoaderService: LmsLoaderService,
    private trainDataServie: TrainDataService,
    private configService: ConfigService,
    private appUtilityService: AppUtilityService,
    private contextMenuOperationsService: ContextMenuOperationsService,
    private lmsModuleService: LmsModuleService, 
    public user: UserService) {
    this.configData = this.configService.getConfigData();
    this.tabLevel = this.configData.tabIndex.dialogBox;
    this.popupOpr = {};
    this.popUpServiceSubscription = this.popUpSerives.popupOprObservable.subscribe((data) => {
      this.setAllocateRole();
      this.popupOpr = data;
      this.applyChanges();
      this.windowCode = this.popupOpr.windowCode;
    });

  }

  /**
   * @memberOf DialogOperationComponent
   */
  ngOnInit() {
  }

  /**
   * @memberOf DialogOperationComponent
   */
  ngOnChanges() {
  }

  /**
   * @private
   * @memberOf DialogOperationComponent
   */
  private applyChanges() {
    if (this.popupOpr && this.popupOpr.operation === 'CancelTrainLocomotivePlan') {
      const title = 'Cancel All Planned Locomotive(s)';
      const message = 'Are you sure you want to cancel all the planned locomotive(s)?';
      this.performCancelLocomotivePlanOperation(title, message);
    } else if (this.popupOpr && this.popupOpr.operation === 'CancelLocomotivePlan') {
      const title = 'Cancel Locomotive(s) Plan';
      const message = 'Are you sure you want to cancel the plan for selected locomotive(s)?';
      this.performCancelLocomotivePlanOperation(title, message);
    } else if (this.popupOpr && this.popupOpr.operation === 'UpdateThp') {
      this.updateThpOperation();
    } else if (this.popupOpr && this.popupOpr.operation === 'userProfilePop') {
      this.showUserProfilePop();
    } else if (this.popupOpr && this.popupOpr.operation === 'locateYardAndLocal') {
      this.showYardAndLocalPop();
    } else if (this.popupOpr && this.popupOpr.operation === 'AllocateLocomotives') {
      this.lmsLoaderService.showLoader();
      this.locomotives = this.popupOpr.data;
      this.checkLocomotiveForAllocate();
    } else if (this.popupOpr && this.popupOpr.operation === 'DeallocateLocomotives') {
      this.lmsLoaderService.showLoader();
      this.locomotives = this.popupOpr.data;
      this.checkLocomotiveForDeallocate();
    }

  }

  /**
   * @private
   * @memberOf DialogOperationComponent
   */
  private showUserProfilePop() {
    this.popupErrorMessage = 'User Profile';
    this.errorDialog = false;
    this.isShowUserProfile = true;
    this.initWindowCount = 5;
    this.popUpSerives.setPageMode('Dialog');
    this.popUpSerives.setSubmitBtnId('userProfileDefaultBtn');
    setTimeout(() => {
      this.appUtilityService.setFocusToFirstElement('dialogUserPrefWindow');
    }, 20);
  }

  /**
     * Set Thp Type for UTHP
     * @private
     * @memberof DialogOperationComponent
     */
  private checkThpPlanType() {
    if ('Svc Ctr/Shop' === this.locomotive.thpType || 'Svc Ctr/Shop' === this.locomotive.thpText || 'S' === this.locomotive.thpType) {
      this.thpPlan = 'S';
    } else if ('Truck Fuel' === this.locomotive.thpType || 'Truck Fuel' === this.locomotive.thpText || 'T' === this.locomotive.thpType) {
      this.thpPlan = 'T';
    } else if ('Main Track' === this.locomotive.thpType || 'Main Track' === this.locomotive.thpText || 'M' === this.locomotive.thpType) {
      this.thpPlan = 'M';
    } else if ('Storage' === this.locomotive.thpType || 'Storage' === this.locomotive.thpText || 'X' === this.locomotive.thpType) {
      this.thpPlan = 'X';
    } else {
      this.thpPlan = '';
    }
    if ('S' === this.thpPlan && !this.appUtilityService.isValidThpSelection(this.locomotive.thpTerminal)) {
      this.thpPlan = '';
    }
    if ('X' === this.thpPlan && this.user && this.user.isUserManagerOrDirector) {
      this.thpPlan = '';
    }

  }

  getTerminalCityState(terminalMnemonic: string): string {
    if (this.terminalCommonInfoArr && terminalMnemonic) {
      const terminalCommonInfo: TerminalCommonInfo = _.find(this.terminalCommonInfoArr,
        { 'terminalMnemonic': terminalMnemonic.trim().toUpperCase() });
      if (terminalCommonInfo && terminalCommonInfo.city && terminalCommonInfo.stateCode) {
        return terminalCommonInfo.city.trim() + ', ' + terminalCommonInfo.stateCode.trim();
      }
    }
    return '-';
  }

  /**
   * @private
   * @memberOf DialogOperationComponent
   */
  private updateThpOperation() {
    this.errorDialog = false;
    const commonopsPicklist = this.staticDataStoreService.getValue('commonopsPicklist');
    this.popupErrorMessage = 'Update Terminal Handling Plan';
    this.isShowTerminalPlan = true;
    this.locomotive = this.popupOpr.locomotive;
    setTimeout(() => {
      this.appUtilityService.setFocusToFirstElement('dialogCancelThpCommon');
    }, 20);
    this.checkThpPlanType();
    if (commonopsPicklist && commonopsPicklist.setOfTerminals) {
      this.terminalCommonInfoArr = [];
      this.terminalCommonInfoArr = commonopsPicklist.setOfTerminals;
    }
    this.locomotiveIdentifier = this.appUtilityService.formatLocomotiveIdForDispaly(this.locomotive.locomotiveIdentifier);
    this.popUpSerives.setPageMode('Dialog');
    this.popUpSerives.setSubmitBtnId('commonThpUpdtBtn');
    this.searchTerminalMenmonicError = false;
  }

  /**
   * @memberOf DialogOperationComponent
   */
  cancelThpOperation() {
    this.errorDialog = false;
    this.isShowTerminalPlan = false;
    this.popUpSerives.setPageMode('');
    this.popUpSerives.setSubmitBtnId('');
    this.searchTerminalMenmonicError = false;
  }

  /**
   * Update terminal handling plan.
   * @returns
   * @memberOf DialogOperationComponent
   */
  submitThpOperation(addToPending?: string) {
    // this.lmsLoaderService.showLoader();
    const terminalHandlingUpdateRequest = this.buildUpdateRquest();
    let sendInPending = false;

    if (addToPending === 'submit' && this.popupOpr.addToPendingList && this.popupOpr.addToPendingList.length > 0) {
      // if trigger from terminal screen
      //  then send in add to pending  for all submit
      sendInPending = true;
    } else if (addToPending === 'addToPending') {
      sendInPending = true;
    } else {
      sendInPending = false;
    }

    if (sendInPending) {
      const addToPendingdata = (addToPending === 'submit') ? false : true;
      this.contextMenuOperationsService.setContextMewnuOperation({ request: terminalHandlingUpdateRequest, popupOperation: this.popupOpr, windowCode: this.windowCode, action: 'updateThp', addToPendingStatus: addToPendingdata });
      this.isShowTerminalPlan = false;
      this.popUpSerives.setPageMode('');
      this.popUpSerives.setSubmitBtnId('');
    } else {
      this.popUpSerives.updateThp(terminalHandlingUpdateRequest, this.windowCode).subscribe(
        (data) => {
          this.responseHeader = <BaseResponse>data;
          if (this.isNumeric(this.responseHeader.header.priorityCode)) {
            const pCode = parseInt(this.responseHeader.header.priorityCode, 10);
            if (pCode >= 1 && pCode <= 4) {
              if (this.popupOpr && this.popupOpr.screenName && this.popupOpr.screenName === 'terminal-status') {
                this.contextMenuOperationsService.setcontextMenuServiceData({
                  status: true, message: 'Terminal Handling Plan for "' + this.formatLocomotiveIdForDispaly(this.locomotive.locomotiveIdentifier)
                    + '" has been updated'
                });
              } else {
                this.lmsLoaderService.hideLoader();
                this.popUpSerives.updateSuccess({
                  action: true,
                  message: 'Terminal Handling Plan for "' + this.formatLocomotiveIdForDispaly(this.locomotive.locomotiveIdentifier)
                    + '" has been updated.'
                });
              }
              this.isShowTerminalPlan = false;
              this.popUpSerives.setPageMode('');
              this.popUpSerives.setSubmitBtnId('');
            } else {
              this.lmsLoaderService.hideLoader();
              this.errorDialog = true;
              this.popupErrorMessage = this.responseHeader.header.messageText;
            }
          }
        }, error => {
          this.lmsLoaderService.hideLoader();
          this.errorDialog = true;
          this.popupErrorMessage = this.appUtilityService.getHttpErroMessage(error, false);
        }
      );
    }
  }

  /**
   * Build Request parameter for update terminal handling.
   * @private
   * @returns {TerminalHandlingUpdateRequest}
   * @memberOf DialogOperationComponent
   */
  private buildUpdateRquest(): TerminalHandlingUpdateRequest {
    const terminalHandlingLocoInfo = {
      locomotiveID: this.formatLocomotiveIdForRequest(this.locomotive.locomotiveIdentifier)
    };
    const terminalHandlingLocoInfoArr: Array<TerminalHandlingLocoInfo> = [];
    terminalHandlingLocoInfoArr.push(terminalHandlingLocoInfo);

    const terminalHandlingUpdateRequest = {
      thpTerminal: this.locomotive.thpTerminal,
      terminalHandlingType: this.thpPlan,
      otherLocosList: terminalHandlingLocoInfoArr
    };
    return terminalHandlingUpdateRequest;
  }

  /**
   * Select value from terminal mnemonic autocomplete.
   * @param {string} value
   * @memberOf DialogOperationComponent
   */
  selectValueFromAutoComplete(value: string) {
    let emitValue = value;
    const commonopsPicklist = this.staticDataStoreService.getValue('commonopsPicklist');
    if (commonopsPicklist) {
      const data = commonopsPicklist.mapOfMnemonis ? commonopsPicklist.mapOfMnemonis : null;
      if (data) {
        if (data[value]) {
          emitValue = data[value];
        }
      }
    }
    this.searchTerminalMenmonic = emitValue;

  }

  /**
   * Auto complete list for terminal mnemonic.
   * @param {any} event
   * @memberOf DialogOperationComponent
   */
  autoCompleteForTerminal(event) {
    this.mnemonics = [];
    this.mileposts = [];
    this.filteredResults = [];
    const commonopsPicklist = this.staticDataStoreService.getValue('commonopsPicklist');
    if (commonopsPicklist) {
      const data = commonopsPicklist.mapOfMnemonis ? commonopsPicklist.mapOfMnemonis : null;
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          this.mnemonics.push(data[key]);
          this.mileposts.push(key);
        }
      }
    }
    this.filteredResults = this.mnemonics.filter((s) => {
      return s.startsWith(event.query.toUpperCase());
    });

    Array.prototype.push.apply(this.filteredResults, (this.mileposts.filter((s) => {
      return s.startsWith(event.query.toUpperCase());
    })));
    this.filteredResults = this.filteredResults.filter(function (item, index, inputArray) {
      return inputArray.indexOf(item) === index;
    });
    this.filteredResults.sort();
  }

  /**
   * @private
   * @param {string} value
   * @returns {string}
   * @memberOf DialogOperationComponent
   */
  private formatLocomotiveIdForDispaly(value: string): string {
    if (value) {
      value = value.trim();
      const v = value.match(/\d+/);
      if (v) {
        const locoInitial = (v.index <= 4) ? value.substring(0, v.index).trim() : value.substring(0, 4).trim();
        const locoNumber = (v.index <= 4) ? value.substring(v.index, value.length).trim() : value.substring(4, value.length).trim();
        return locoInitial + ' ' + locoNumber.replace(/^0+/, '');
      }
    }
  }

  /**
   * @private
   * @param {string} value
   * @returns {string}
   *
   * @memberOf DialogOperationComponent
   */
  private formatLocomotiveIdForRequest(value: string): string {
    let formattedValue = value;
    if (value) {
      value = value.trim();
      const v = value.match(/\d+/);
      if (v) {
        const locoInitial = (v.index <= 4) ? value.substring(0, v.index).trim() : value.substring(0, 4).trim();
        const locoNumber = (v.index <= 4) ?
          value.substring(v.index, value.length).trim() : value.substring(4, value.length).trim();

        if (this.isNumeric(locoNumber)) {
          formattedValue = this.rightPad(locoInitial, ' ', 4) + '    ' + this.leftPad(locoNumber, '0', 6);
        }
      }
    }
    return formattedValue;
  }

  /**
   * @private
   * @param {any} str
   * @param {any} padString
   * @param {any} max
   * @returns {string}
   *
   * @memberOf DialogOperationComponent
   */
  private rightPad(str, padString, max): string {
    str = str.toString();
    return str.length < max ? this.rightPad(str + padString, padString, max) : str;
  }

  /**
   * @private
   * @param {any} str
   * @param {any} padString
   * @param {any} max
   * @returns {string}
   *
   * @memberOf DialogOperationComponent
   */
  private leftPad(str, padString, max): string {
    str = str.toString();
    return str.length < max ? this.leftPad(padString + str, padString, max) : str;
  }

  /**
   * @private
   * @param {string} value
   * @returns {boolean}
   *
   * @memberOf DialogOperationComponent
   */
  private isNumeric(value: string): boolean {
    if (value) {
      const v = value.match(/^\d+$/);
      if (v) {
        if (v.toString() === value) {
          return true;
        }
      }
    }
    return false;
  }

  /**
   * @private
   * @param {string} title
   * @param {string} message
   *
   * @memberOf DialogOperationComponent
   */
  private performCancelLocomotivePlanOperation(title: string, message: string) {
    this.confirmPop = true;
    this.errorDialog = false;
    this.popUpSerives.setPageMode('Dialog');
    this.popUpSerives.setSubmitBtnId('commonCnclLocoPlanBtn');
    this.confirmAction = title;
    this.confirmMessage = message;
    setTimeout(() => {
      this.appUtilityService.setFocusToFirstElement('dialogCancelLocoPlanCommon');
    }, 20);
  }

  /**
   * @returns
   * @memberOf DialogOperationComponent
   */
  public cancelLocomotivePlan(operation, addToPending?: string) {
    // this.lmsLoaderService.showLoader();
    if (this.popupOpr && this.popupOpr.data) {
      const request = this.popupOpr.data;
      if (!this.windowCode && this.popupOpr.windowCode) {
        this.windowCode = this.popupOpr.windowCode;
      }
      let sendInPending = false;
      if (addToPending === 'submit' && this.popupOpr.addToPendingList && this.popupOpr.addToPendingList.length > 0) {
        // if trigger from terminal screen
        //  then send in add to pending  for all submit
        sendInPending = true;
      } else if (addToPending === 'addToPending') {
        sendInPending = true;
      } else {
        sendInPending = false;
      }

      if (sendInPending) {
        const addToPendingdata = (addToPending === 'submit') ? false : true;
        this.contextMenuOperationsService.setContextMewnuOperation({ request: request, popupOperation: this.popupOpr, windowCode: this.windowCode, action: operation, addToPendingStatus: addToPendingdata });
        this.hideDialog('Cancel Locomotive Plan');
        this.popUpSerives.setPageMode('');
        this.popUpSerives.setSubmitBtnId('');
      } else {
        this.popUpSerives.cancelLocomotivePlan(request, this.popupOpr.currentTerminal, this.windowCode).subscribe(
          (data) => {
            this.responseHeader = data;
            if (this.isNumeric(this.responseHeader.header.priorityCode)) {
              const pCode = parseInt(this.responseHeader.header.priorityCode, 10);
              if (pCode >= 1 && pCode <= 4) {
                this.hideDialog('Cancel Locomotive Plan');
                if (this.popupOpr && this.popupOpr.screenName && this.popupOpr.screenName === 'terminal-status') {
                  this.contextMenuOperationsService.setcontextMenuServiceData({
                    status: true, message: this.responseHeader.header.messageText
                  });
                } else {
                  this.lmsLoaderService.hideLoader();

                  if (this.windowCode && (this.windowCode.toUpperCase() === 'LWTD' || this.windowCode.toUpperCase() === 'LWLS')) {
                    this.popUpSerives.updateSuccess({ action: true, message: this.responseHeader.header.messageText });
                  } else {
                    this.messageHandlerService.handleMessage(<MessageDetails>({
                      type: this.configData.message.type.client,
                      level: this.configData.message.level.success,
                      target: this.configData.message.target.page,
                      message: this.responseHeader.header.messageText
                    }));
                  }
                }
                this.popUpSerives.setPageMode('');
                this.popUpSerives.setSubmitBtnId('');
              } else {
                this.lmsLoaderService.hideLoader();
                this.errorDialog = true;
                this.confirmAction = this.responseHeader.header.messageText;
              }
            }
          }, error => {
            this.errorDialog = true;
            this.confirmAction = this.appUtilityService.getHttpErroMessage(error, false);
            this.lmsLoaderService.hideLoader();
          }
        );
      }
    } else {
      return;
    }
  }

  /**
   * @private
   * @param {LocoDetail[]} locos
   * @returns
   *
   * @memberOf DialogOperationComponent
   */
  private getSelectedLocomotives(locos: LocoDetail[]) {
    const selection = [];
    for (let i = 0; i < locos.length; i++) {
      const loco = locos[i];
      const select = {
        rowID: '',
        locomotiveID: this.formatLocomotiveIdForRequest(loco.locomotiveIdentifier),
        assignedPlannedFlag: loco.assignedPlannedFlag,
        qualifier: loco.qualifier
      };
      selection.push(select);
    }
    return selection;
  }

  /**
   * Invoked when hide dialog.
   * @param {string} confirmAction
   * @memberOf DialogOperationComponent
   */
  public hideDialog(confirmAction: string) {
    this.errorDialog = false;
    if ('Cancel Locomotive Plan' === confirmAction) {
      this.confirmPop = false;
      this.confirmAction = null;
      this.confirmMessage = null;
      this.popUpSerives.setPageMode('');
      this.popUpSerives.setSubmitBtnId('');
    } else if ('User Profile' === confirmAction) {
      this.popupErrorMessage = 'User Profile';
      this.isShowUserProfile = false;
      this.initWindowCount = 5;
      this.popUpSerives.setPageMode('');
      this.popUpSerives.setSubmitBtnId('');
    } else if ('allocateLocomotive' === confirmAction) {
      this.allocationType = 'YL';
      this.searchTextAllocationStation = '';
      this.searchAllocationStationError = false;
      this.allocateLocomotive = false;
    } else if ('deAllocateLocomotive' === confirmAction) {
      this.deAllocateLocomotive = false;
    } else if ('permanentAlloc' === confirmAction) {
      this.permanentAllocation = false;
      this.permannentAllocDialog = false;
    } else if ('permannentAllocForDealloc' === confirmAction) {
      this.permanentAllocation = false;
      this.permannentAllocForDeallocDialog = false;
    }
  }

  /**
   * Invoked when click on confirm button action.
   * @param {string} confirmAction
   * @memberOf DialogOperationComponent
   */
  public confirmbtnAction(confirmAction: string, operation?: string) {
    if ('Cancel Locomotive Plan' === confirmAction) {
      this.cancelLocomotivePlan(confirmAction, operation);
    }
  }

  /**
   * Invoked when cancel user profile popup.
   * @param {any} event
   * @memberOf DialogOperationComponent
   */
  cancelUserProfilePopup(event) {
    if (event) {
      this.isShowUserProfile = false;
    }
  }

  /**
   * Invoked for open error dialog.
   * @param {any} event
   * @memberOf DialogOperationComponent
   */
  isOpenErrorDialog(event) {
    this.errorDialog = event;
  }

  /**
   * Display popup error.
   * @param {any} event
   * @memberOf DialogOperationComponent
   */
  displayPopupError(event) {
    this.popupErrorMessage = event;
  }

  /**
   * Destroy the state of lifecycle hook.
   * @memberOf DialogOperationComponent
   */
  ngOnDestroy() {
    this.popUpServiceSubscription.unsubscribe();
  }

  showYardAndLocalPop() {
    this.yardAndLocal = true;
    this.popUpSerives.setPageMode('Dialog');
    this.popUpSerives.setSubmitBtnId('yardAndLocalLocoData');
    setTimeout(() => {
      this.appUtilityService.setFocusToFirstElement('dialogYardAndLocalCommon');
    }, 20);
  }

  cancelYardAndLocalPopup(event) {
    if (event) {
      this.yardAndLocal = false;
      this.popUpSerives.setPageMode('');
      this.popUpSerives.setSubmitBtnId('');
    }
  }

  /**
 * Autoomplete for allocation station.
 *
 * @param {any} event
 *
 */
  autoCompleteForAllocationStation(event) {
    this.filteredResults = [];
    this.commonopsPicklist = this.appUtilityService.validateCommonPickList(this.commonopsPicklist);
    if (this.commonopsPicklist && this.commonopsPicklist.masterData) {
      this.allocationStationArr = this.commonopsPicklist.masterData.allocationStationList;
      for (const allocStation of this.allocationStationArr) {
        this.filteredResults.push(allocStation.allocationStation);
      }
      this.filteredResults = this.filteredResults.filter((s) => {
        return s.startsWith(event.query.toUpperCase());
      });
      this.filteredResults.sort();
    }
  }

  /**
   * Invoked when select value from station autocomplete.
   *
   * @param {string} value
   *
   */
  selectValueFromStationAutoComplete(value: string) {
    if (value) {
      this.searchAllocationStationError = false;
      this.searchTextAllocationStation = value;
    }
  }

  /**
   * Invoked for submit allocate locomotive operation.
   * @memberof YardLocalDataComponent
   */
  submitAllocateLocomotive() {
    this.searchAllocationStationError = false;
    this.lmsLoaderService.showLoader();
    if (this.searchTextAllocationStation && this.appUtilityService.isAllocationStationExist(this.searchTextAllocationStation)) {
      const allocDeallocData = this.buildRequestParamForAllocate();
      this.popUpSerives.allocateLocomotives(allocDeallocData, this.windowCode).subscribe(data => {
        this.allocateDeallocateResponse = <Header>data;
        if (this.allocateDeallocateResponse && this.allocateDeallocateResponse.priorityCode) {
          const pCode = parseInt(this.allocateDeallocateResponse.priorityCode, 10);
          if (pCode >= 1 && pCode <= 4) {
            this.lmsLoaderService.hideLoader();
            this.allocateLocomotive = false;
            const operation = {
              operation: 'allocateSuccess',
              message: this.allocateDeallocateResponse.messageText
            };
            this.popUpSerives.setPopupOperation(operation);
          } else {
            this.lmsLoaderService.hideLoader();
            this.errorDialog = true;
            this.popupErrorMessage = this.allocateDeallocateResponse.messageText;
          }
        }
      }, error => {
        this.lmsLoaderService.hideLoader();
        this.errorDialog = true;
        this.popupErrorMessage = this.appUtilityService.getHttpErroMessage(error, false);
      });
    } else {
      this.lmsLoaderService.hideLoader();
      this.searchAllocationStationError = true;
    }
  }

  /**
   * Request param for allocate locomotives.
   * @returns {AllocDeallocData}
   */
  buildRequestParamForAllocate(): AllocDeallocData {
    const locoDataList: Array<LocoDetail> = [];
    for (let i = 0; i < this.locomotives.length; i++) {
      const locoDetail: LocoDetail = {
        locomotiveIdentifier: this.appUtilityService.formatLocomotiveId(this.locomotives[i].locomotiveIdentifier),
        assignedPlannedFlag: this.locomotives[i].assignedPlannedFlag
      };
      locoDataList.push(locoDetail);
    }

    const allocDeallocData: AllocDeallocData = {
      allocationStation: this.searchTextAllocationStation.toUpperCase().trim(),
      allocationType: this.allocationType,
      permanentAllocation: this.permanentAllocation ? 'Y' : 'N',
      allocationRole: this.allocateRole,
      locoDataList: locoDataList
    };
    return allocDeallocData;
  }

  /**
   * Check locomotives for allocate operation.
   */
  checkLocomotiveForAllocate() {
    let isLocoError: boolean;
    let errorSelectedCount = 0;
    let locomotiveIds: string;
    for (let k = 0; k < this.locomotives.length; k++) {
      if (this.allocateRole && this.allocateRole === 'YL') {
        isLocoError = false;
      } else if (this.allocateRole && this.allocateRole === 'MW') {
        if (!this.locomotives[k].permanentTag || !this.locomotives[k].locoAllocType ||
          (this.locomotives[k].permanentTag &&
            this.locomotives[k].permanentTag.toUpperCase().trim() !== 'MW') &&
          this.locomotives[k].locoAllocType &&
          this.locomotives[k].locoAllocType.toUpperCase().trim() !== 'MW') {
          errorSelectedCount++;
          if (locomotiveIds) {
            locomotiveIds += ', ' + this.appUtilityService.UIformatLocomotiveId(this.locomotives[k].locomotiveIdentifier);
          } else {
            locomotiveIds = this.appUtilityService.UIformatLocomotiveId(this.locomotives[k].locomotiveIdentifier);
          }
          isLocoError = true;
        }
      }
    }
    if (!isLocoError) {
      this.lmsLoaderService.hideLoader();
      this.checkPermanentAllocLocomotives();
    } else {
      this.lmsLoaderService.hideLoader();
      const messagePart = ((errorSelectedCount) === 1) ? 'is' : 'are';
      const operation = {
        operation: 'allocateLocoError',
        message: `${errorSelectedCount} out of ${this.locomotives.length} locomotives (${locomotiveIds}) ${messagePart} not allowed for this operation. `,
        status: this.configService.getConfigData().tabStatus.error
      };
      this.popUpSerives.setPopupOperation(operation);
    }
  }
  /**
   * Invoked when update tab information in module service.
   * @param {Tab} tab
   */
  public updateTab(tab: Tab) {
    this.lmsModuleService.updateSelectedTab(tab);
  }

  /**
     * Check locomotives for permanent allocation'
     */
  checkPermanentAllocLocomotives() {
    let isLocoError: boolean;
    let errorSelectedCount = 0;
    const permLocos = [];
    this.permannentAllocMsg = '';
    let locomotiveIds = '';
    for (let k = 0; k < this.locomotives.length; k++) {
      if (this.locomotives[k].locoAllocPermFlag &&
        this.locomotives[k].locoAllocPermFlag.toUpperCase().trim() === 'Y') {
        errorSelectedCount++;
        if (permLocos.indexOf(this.appUtilityService.UIformatLocomotiveId(this.locomotives[k].locomotiveIdentifier)) === -1) {
          if (locomotiveIds) {
            locomotiveIds += ', ' + this.appUtilityService.UIformatLocomotiveId(this.locomotives[k].locomotiveIdentifier);
          } else {
            locomotiveIds = this.appUtilityService.UIformatLocomotiveId(this.locomotives[k].locomotiveIdentifier);
          }
          permLocos.push(this.appUtilityService.UIformatLocomotiveId(this.locomotives[k].locomotiveIdentifier));
        }
        isLocoError = true;
      }
    }
    if (!isLocoError) {
      this.permannentAllocDialog = false;
      this.openAllocateLocomotivePopup();
    } else {
      this.permannentAllocDialog = true;
      const messagePart = ((errorSelectedCount) === 1) ? `Locomotive (${locomotiveIds}) has` : `Locomotives (${locomotiveIds}) have`;
      this.permannentAllocMsg = `${messagePart} a Permanent Allocation, Do you want to change the Allocation of the locomotive?`;
    }
  }

  /**
   * Invoked through click on allocation option.
   */
  openAllocateLocomotivePopup() {
    this.permannentAllocDialog = false;
    this.setAllocateRole();
    this.errorDialog = false;
    this.searchTextAllocationStation = '';
    this.searchAllocationStationError = false;
    this.permanentAllocation = false;
    this.popupErrorMessage = 'Allocate Locomotive';

    if (this.locomotives && this.locomotives.length > 0 && this.locomotives[0].locoAllocStation) {
      setTimeout(() => {
        this.searchTextAllocationStation = this.locomotives[0].locoAllocStation.toUpperCase().trim();
      }, 200);
    }
    if (this.locomotives && this.locomotives.length > 0) {
      this.allocateLocomotive = true;
    }
  }

  /**
   * Open De-allocate locomotive confirmation.
   */
  openDellocateAllocateLocomotivePopup() {
    this.permannentAllocForDeallocDialog = false;
    this.errorDialog = false;
    this.popupErrorMessage = 'Confirmation';
    this.deAllocateLocomotive = true;
  }

  /**
 * Set allocation/de-allocation role.
 */
  setAllocateRole() {
    this.commonopsPicklist = this.appUtilityService.validateCommonPickList(this.commonopsPicklist);
    if (this.commonopsPicklist &&
      this.commonopsPicklist.masterData &&
      this.commonopsPicklist.masterData.userAuthDetails &&
      this.commonopsPicklist.masterData.userAuthDetails.allocationRole) {
      this.allocateRole = this.commonopsPicklist.masterData.userAuthDetails.allocationRole;
      if (this.allocateRole === 'MW') {
        this.allocationType = 'MW';
      } else {
        this.allocationType = 'YL';
      }
    } else {
      this.allocationType = 'YL';
    }
  }

  /**
   * Check locomotives for deallocate operation.
   */
  checkLocomotiveForDeallocate() {
    let isLocoError: boolean;
    let errorSelectedCount = 0;
    let unAllocatedLocoCount = 0;
    let locomotiveIds: string;
    let unAllocatedLocomotiveIds: string;
    for (let i = 0; i < this.locomotives.length; i++) {
      if (!this.locomotives[i].locoAllocStation || (this.locomotives[i].locoAllocStation && this.locomotives[i].locoAllocStation.trim().length === 0)) {
        unAllocatedLocoCount++;
        if (unAllocatedLocomotiveIds) {
          unAllocatedLocomotiveIds += ', ' + this.appUtilityService.UIformatLocomotiveId(this.locomotives[i].locomotiveIdentifier);
        } else {
          unAllocatedLocomotiveIds = this.appUtilityService.UIformatLocomotiveId(this.locomotives[i].locomotiveIdentifier);
        }
      }
    }
    if (unAllocatedLocoCount === 0) {
      for (let k = 0; k < this.locomotives.length; k++) {
        if (this.allocateRole && this.allocateRole === 'YL') {
          isLocoError = false;
        } else if (this.allocateRole && this.allocateRole === 'MW') {
          // check for allocateion, allocate role is 'MW' and permanent flag and allocation type.
          if (!this.locomotives[k].permanentTag || !this.locomotives[k].locoAllocType ||
            (this.locomotives[k].permanentTag &&
              this.locomotives[k].permanentTag.toUpperCase().trim() !== 'MW') &&
            this.locomotives[k].locoAllocType &&
            this.locomotives[k].locoAllocType.toUpperCase().trim() !== 'MW') {
            errorSelectedCount++;
            if (locomotiveIds) {
              locomotiveIds += ', ' + this.appUtilityService.UIformatLocomotiveId(this.locomotives[k].locomotiveIdentifier);
            } else {
              locomotiveIds = this.appUtilityService.UIformatLocomotiveId(this.locomotives[k].locomotiveIdentifier);
            }
            isLocoError = true;
          }
        }
      }
      if (!isLocoError) {
        this.lmsLoaderService.hideLoader();
        this.checkPermanentAllocLocomotivesForDealloc();
      } else {
        this.lmsLoaderService.hideLoader();
        const messagePart = ((errorSelectedCount) === 1) ? 'is' : 'are';
        const operation = {
          operation: 'deAllocateError',
          message: `${errorSelectedCount} out of ${this.locomotives.length} locomotives (${locomotiveIds}) ${messagePart} not allowed for this operation. `,
          status: this.configService.getConfigData().tabStatus.error
        };
        this.popUpSerives.setPopupOperation(operation);
      }
    } else {
      this.lmsLoaderService.hideLoader();
      const messagePart = ((unAllocatedLocoCount) === 1) ? 'Locomotive (' + unAllocatedLocomotiveIds + ') is not currently Allocated.' : 'Locomotives (' + unAllocatedLocomotiveIds + ') are not currently Allocated.';
      const operation = {
        operation: 'deAllocateError',
        message: 'Cannot Deallocate - ' + messagePart,
        status: this.configService.getConfigData().tabStatus.error
      };
      this.popUpSerives.setPopupOperation(operation);
    }
  }

  /**
     * Check locomotives for permanent allocation'
     */
  checkPermanentAllocLocomotivesForDealloc() {
    let isLocoError: boolean;
    let errorSelectedCount = 0;
    this.permannentAllocMsg = '';
    let locomotiveIds = '';
    for (let k = 0; k < this.locomotives.length; k++) {
      if (this.locomotives[k].locoAllocPermFlag &&
        this.locomotives[k].locoAllocPermFlag.toUpperCase().trim() === 'Y') {
        errorSelectedCount++;
        if (locomotiveIds) {
          locomotiveIds += ', ' + this.appUtilityService.UIformatLocomotiveId(this.locomotives[k].locomotiveIdentifier);
        } else {
          locomotiveIds = this.appUtilityService.UIformatLocomotiveId(this.locomotives[k].locomotiveIdentifier);
        }
        isLocoError = true;
      }
    }
    if (!isLocoError) {
      this.permannentAllocForDeallocDialog = false;
      this.errorDialog = false;
      this.popupErrorMessage = 'Confirmation';
      this.deAllocateLocomotive = true;
    } else {
      this.permannentAllocForDeallocDialog = true;
      const messagePart = ((errorSelectedCount) === 1) ? `Locomotive (${locomotiveIds}) has` : `Locomotives (${locomotiveIds}) have`;
      this.permannentAllocMsg = `${messagePart} a Permanent Allocation, Do you want to change the Allocation of the locomotive?`;
    }
  }
  /**
   * @param {PageMode} pageMode
   */
  setPageModeData(btnId: string, dialogId?: string) {
    if (btnId && btnId.length > 0) {
      this.popUpSerives.setPageMode('Dialog');
      this.popUpSerives.setSubmitBtnId(btnId);
      setTimeout(() => {
        this.appUtilityService.setFocusToFirstElement(dialogId);
      }, 20);
    } else {
      this.popUpSerives.setPageMode('');
      this.popUpSerives.setSubmitBtnId('');
    }
  }

  showAllocateDialog(){
    this.errorDialog = false;
    this.searchTextAllocationStation = '';
    this.searchAllocationStationError = false;
    this.permanentAllocation = false;
    this.popupErrorMessage = 'Allocate Locomotive';
  }

  /**
   * Submit deallocate locomotive.
   * @memberof YardLocalDataComponent
   */
  submitDeallocateLocomotives() {
    this.lmsLoaderService.showLoader();
    const allocDeallocData = this.buildRequestParamForDeallocate();
    this.popUpSerives.deAllocateLocomotives(allocDeallocData, this.windowCode).subscribe(data => {
      this.allocateDeallocateResponse = <Header>data;
      if (this.allocateDeallocateResponse && this.allocateDeallocateResponse.priorityCode) {
        const pCode = parseInt(this.allocateDeallocateResponse.priorityCode, 10);
        if (pCode >= 1 && pCode <= 4) {
          this.popupErrorMessage = 'Confirmation';
          this.errorDialog = false;
          this.deAllocateLocomotive = false;
          this.lmsLoaderService.hideLoader();
          const operation = {
            operation: 'deallocateSuccess',
            message: this.allocateDeallocateResponse.messageText
          };
          this.popUpSerives.setPopupOperation(operation);
        } else {
          this.lmsLoaderService.hideLoader();
          this.errorDialog = true;
          this.popupErrorMessage = this.allocateDeallocateResponse.messageText;
        }
      }
    }, error => {
      this.lmsLoaderService.hideLoader();
      this.errorDialog = true;
      this.popupErrorMessage = this.appUtilityService.getHttpErroMessage(error, false);
    });
  }

  /**
   * Request param for de-allocate locomotives.
   * @returns {AllocDeallocData}
   */
  buildRequestParamForDeallocate(): AllocDeallocData {
    const locoDataList: Array<LocoDetail> = [];
    for (let i = 0; i < this.locomotives.length; i++) {
      const locoDetail: LocoDetail = {
        locomotiveIdentifier: this.appUtilityService.formatLocomotiveId(this.locomotives[i].locomotiveIdentifier),
        assignedPlannedFlag: this.locomotives[i].assignedPlannedFlag
      };
      locoDataList.push(locoDetail);
    }
    const allocDeallocData: AllocDeallocData = {
      allocationRole: this.allocateRole,
      locoDataList: locoDataList
    };
    return allocDeallocData;
  }
}

